import { getConfig, getRequestHeaders } from '../config';
import { RETOUCHING_MTCC_FUNC_CODE } from '../constants';
import type { ImageResultBatchResponse, RawResponse } from '../type';

// 商品精修投递算法
export async function retouchingDeliver(params: {
    originalImageURL: string;
    maskURL?: string;
    subfunc: 'editor_ai_goods_fix' | 'commerce_ai_goods_fix';
    transfer?: string;
    transferID?: string;
    fromDemo?: boolean;
    v2Params?: Record<string, any>;
}) {
    const { request, requestOptions } = getConfig();
    const headers = await getRequestHeaders(RETOUCHING_MTCC_FUNC_CODE);

    let url = '/v1/mtlab/aigoodsfix_v2_async';
    const mediaInfoList = [
        {
            media_data: params.originalImageURL,
            media_profiles: {
                media_data_type: 'url',
            },
        },
    ];

    if (params.maskURL) {
        url = '/v1/mtlab/aigoodsfix_async';
        mediaInfoList.push({
            media_data: params.maskURL,
            media_profiles: {
                media_data_type: 'url',
            },
        });
    }

    const res = await request<RawResponse<{ msg_id: string }>>(`${requestOptions?.baseURL || ''}${url}`, {
        method: 'POST',
        data: {
            media_info_list: mediaInfoList,
            parameter: {
                rsp_media_type: 'url',
                res_upsample: false, // 超分
            },
        },
        params: {
            save_to_own_bucket: params.transfer,
            subfunc: params.subfunc,
            from_demo: params?.fromDemo ? 1 : 0,
            transfer_id: params.transferID,
            ...(params.v2Params || {}),
        },
        headers,
    });

    const { code, message, data } = res.data;
    if (code === 0 && data) {
        return data.msg_id;
    }

    throw new Error(message);
}

// 批量查询异步任务结果
export async function queryDeliverResults(ids: string[]) {
    const { request, requestOptions } = getConfig();

    const res = await request<RawResponse<ImageResultBatchResponse[]>>(
        `${requestOptions?.baseURL || ''}/v1/mtlab/query_multi`,
        {
            method: 'GET',
            params: { msg_ids: ids.join(',') },
            headers: {
                'Content-Type': 'application/json',
                ...(requestOptions?.headers || {}),
            },
        },
    );

    const { code, message, data } = res.data;
    if (code === 0 && data) {
        return data;
    }

    throw new Error(message);
}
